import { useMemo } from "react";

import { isNil } from "lodash";

import { useSwrFetch } from "./useSwrFetch";

interface UseCompanyHasPaymentMethodProps {
  companyId: number | null;
  // Keeps the Stripe round trip off the plans that cannot be missing a card.
  enabled: boolean;
}

interface UseCompanyHasPaymentMethodResult {
  // Null until the lookup resolves, so a caller cannot read an unfinished fetch
  // as a missing payment method.
  hasPaymentMethod: boolean | null;
  loading: boolean;
  error: string | null;
}

export function useCompanyHasPaymentMethod(
  props: UseCompanyHasPaymentMethodProps,
): UseCompanyHasPaymentMethodResult {
  const { companyId, enabled } = props;

  const url = useMemo(
    () =>
      enabled && !isNil(companyId)
        ? `/stripe/companies/${companyId}/has-payment-method`
        : null,
    [companyId, enabled],
  );

  const { data, loading, error } = useSwrFetch<HasPaymentMethodResponse>({
    url,
    errorMessage:
      "Failed to check payment method availability. Please contact us if the issue persists.",
  });

  return {
    hasPaymentMethod: data?.has_payment_method ?? null,
    loading,
    error,
  };
}
